<template>
  <!-- 扣分详情 -->
  <div class="deduct_detail">
    <div class="head">
      <div class="head_left">
        <div class="head_title">{{ detailMsg.accidentName }}</div>
        <div class="tags">
          <span>{{ detailMsg.areaName }}</span>
          <!-- <span>{{ detailMsg.areaType == 1 ? "一类地区" : "二类地区" }}</span> -->
        </div>
        <div class="time">{{ detailMsg.monitorDate }}</div>
      </div>
      <div class="head_right">
        <div class="deduct_score"  :class="{'line_through': isExceed == '1' && detailMsg.audited == 1 }">-{{ accidentScore }}</div>
        <!-- <div class="percent" v-if="detailMsg.audited != 0">{{ surplusScore }}/10.0</div> -->
        <div class="status">{{ detailMsg.audited == 0 ? "未审核" : "" }}</div>
        <div v-if="isExceed == '1' && detailMsg.audited == 1" class="status">已达扣分上限</div>
      </div>
    </div>
    <div class="content">
      <div v-if="detailMsg.deductionReason" class="deal_desc">
        <div class="tit">扣分原因</div>
        <div
          class="desc more_desc"
          ref="showMoreDesc"
          :class="{ show_more: showMoreDesc }"
        >{{ detailMsg.deductionReason }}</div>
        <div class="open_more" v-show="oprate_dom_desc">
          <span v-show="showMoreDesc" @click="openMore('Desc')">展开</span>
          <span v-show="!showMoreDesc" @click="openMore('Desc')">收起</span>
          <i v-show="showMoreDesc" class="drop_down"></i>
          <i v-show="!showMoreDesc" class="drop_up"></i>
        </div>
        <!-- <div class="desc">{{ detailMsg.deductionReason }}</div> -->
      </div>
      <div class="deduct_reason">
        <div class="tit">事故级别</div>
        <div class="desc">{{ detailMsg.accidentLevelCN }}</div>
      </div>
      <div class="happend_time">
        <div class="tit">事故发生时间</div>
        <div class="desc">{{ detailMsg.accidentTime }}</div>
      </div>
      <div class="deal_desc">
        <div class="tit">事故处理情况</div>
        <div
          class="desc more_desc"
          ref="showMore"
          id="showMore"
          :class="{ show_more: showMore }"
        >{{ detailMsg.accidentDesc }}</div>
        <div class="open_more" v-show="oprate_dom">
          <span v-show="showMore" @click="openMore">展开</span>
          <span v-show="!showMore" @click="openMore">收起</span>
          <i v-show="showMore" class="drop_down"></i>
          <i v-show="!showMore" class="drop_up"></i>
        </div>
      </div>
      <div class="related_file">
        <div class="file_title">相关材料</div>
        <div class="file_item" v-for="item in detailMsg.fileResVOS" :key="item.id">
          <div class="file_msg" @click="openFile(item)">
            <img v-if="item.fileType === 'exl'" src="@/assets/appraise/ic_exl.png" alt />
            <img v-if="item.fileType === 'doc'" src="@/assets/appraise/ic_doc.png" alt />
            <img v-if="item.fileType === 'pdf'" src="@/assets/appraise/ic_pdf.png" alt />
            <p class="file_name">
              <span>{{ item.fileName }}{{'.'+item.fileType}}</span>
            </p>
          </div>
          <div class="file_size">{{ item.fileSize }}</div>
        </div>
      </div>
    </div>
    <div class="bot_btn" v-if="detailMsg.audited == 0 && false">
      <btnauth custype="apply" :year="year" :quarter="quarter">
        <div class="opreate">
          <div class="delete_btn" @click="deleteSituation" v-if="deleteAuth === 'OPERATION03'">
            <img src="@/assets/appraise/delete.png" alt />
            <span class>删除</span>
          </div>
          <!-- <btnauth custype="apply" :year="year" :quarter="quarter"> -->
          <div class="edit_btn" @click="editSituation" v-if="updateAuth === 'OPERATION02'">
            <img src="@/assets/appraise/Group 2@2x.png" alt />
            <span>编辑</span>
          </div>
          <!-- </btnauth> -->
        </div>
      </btnauth>
      <btnauth custype="audit" :year="year" :quarter="quarter">
        <div class="check_btn" v-if="userAuthoirese === 'OPERATION06'">
          <van-button @click="check" type="primary">审核</van-button>
        </div>
      </btnauth>
    </div>
    <titleDialog
      v-if="showDialog"
      :title="dialogTitle"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></titleDialog>
    <modalIframe :url="iframeurl"></modalIframe>
  </div>
</template>

<script>
import api from "@/service/modules/appraiseNew.js";
import titleDialog from "../components/titleDialog.vue";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
import btnauth from "../appraiseNew/components/btnauth";
import modalIframe from '../appraiseNew/components/modalIframe';
export default {
  components: {
    titleDialog,
    btnauth,
    modalIframe
  },
  data() {
    return {
      showDialog: false,
      dialogTitle: "",
      cancelBtn: "",
      confirmBtn: "",
      accidentScore: 0,
      surplusScore: 10,
      detailMsg: {},
      showMore: true,
      showMoreDesc: true,
      oprate_dom: true,
      oprate_dom_desc: true,
      //权限字段
      // 3个操作权限
      userAuthoirese: this.$route.query.userAuthoirese,
      updateAuth: this.$route.query.updateAuth,
      deleteAuth: this.$route.query.deleteAuth,
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      iframeurl:'',
      isExceed: this.$route.query.isExceed
    };
  },
  created() {
    this.queryDetail();
  },
  updated() {
    this.$nextTick(() => {
            if (this.detailMsg.accidentDesc&&this.detailMsg.accidentDesc.length<120) {
              this.oprate_dom = false;
            }
            if (this.detailMsg.deductionReason&&this.detailMsg.deductionReason.length<120) {
              this.oprate_dom_desc = false;
            }
          });
  },
  methods: {
    // 查询详情
    queryDetail() {
      let params = {
        id: this.$route.query.id,
      };
      api.querySaveDetail(params).then((res) => {
        if (res.ret == 0) {
          this.detailMsg = res.data;
          this.accidentScore = (this.detailMsg.deduction / 100).toFixed(1);
          this.surplusScore = ((1000 - this.detailMsg.deduction) / 100).toFixed(
            1
          );
        }
      });
    },
    // 审核
    check() {
      const { area, year, quarter } = this.$route.query;
      this.$router.push(
        `/appraise/checkSituation?id=${this.detailMsg.id}&year=${year}&area=${area}&quarter=${quarter}`
      );
    },
    // 删除情况
    deleteSituation() {
      (this.dialogTitle = "是否确定删除"),
        (this.cancelBtn = "取消"),
        (this.confirmBtn = "删除"),
        (this.showDialog = true);
    },
    // 编辑
    editSituation() {
      const { area, year, quarter } = this.$route.query;
      this.$router.push(
        `/appraise/addSituation?id=${this.detailMsg.id}&year=${year}&area=${area}&quarter=${quarter}`
      );
    },
    // 弹窗确认回调
    confirm() {
      const { area, year, quarter } = this.$route.query;
      this.showDialog = false;
      let params = {
        id: this.$route.query.id,
      };
      api.deleteTripAccident(params).then((res) => {
        if (res.ret == 0) {
          this.$Toast({
            message: "删除成功",
            icon,
          });
          setTimeout(() => {
            // this.$router.replace(
            //   `/appraise/travelAccident?year=${year}&area=${area}&quarter=${quarter}`
            // );
            this.$router.back(-1);
          }, 2000);
        }
      });
    },
    /**
     * @description: 打开附件
     * @param { item } object
     */
    openFile(item) {
      const _this = this;
      const str = navigator.userAgent.toLowerCase();
      const ver = str.match(/cpu iphone os (.*?) like mac os/);
      if (!ver) {
        console.log("---安卓进来这里url:", item.fileUrl);
        // this.$toast('当前暂不支持预览附件')
        // console.log('不是苹果')
        this.iframeurl = item.fileUrl
        // this.$router.push({
        //   path: "/appraise/iframepdf",
        //   query: { url: item.fileUrl },
        // });
      } else {
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: item.fileUrl,
            isFullScreen: 0,
            setTitle: name,
            needLoading: 1,
          },
          (cb) => {
            console.log(cb, "callback");
          }
        );
      }
       setTimeout( ()=>{
        _this.iframeurl = ''
      }, 100)
    },
    openMore(type) {
      type = typeof type == "object" ? "" : type;
      this[`showMore${type}`] = !this[`showMore${type}`];
    },
    // 弹窗失败回调
    cancel() {
      this.showDialog = false;
    },
  },
};
</script>

<style scoped lang="less">
.deduct_detail {
  padding-bottom: 60px;
  .head {
    display: flex;
    justify-content: space-between;
    padding: 10px 12px;
    width: 100%;
    border-bottom: 1px solid #eee;
  }
  .head_left {
    flex: 1;
    .head_title {
      margin: 14px 0 12px;
      // color: #333;
      font-size: 20px;
      font-weight: bold;
    }
    .tags span {
      display: inline-block;
      margin-right: 9px;
      padding: 1px 4px;
      font-size: 10px;
      line-height: 14px;
      color: #36b374;
      border: 1px solid #36b374;
    }
    .time {
      margin-top: 12px;
      font-size: 12px;
      color: #999;
    }
  }
  .head_right {
    // width: 70px;
    padding-top: 12px;
    // margin-top: 27px;
    text-align: right;
    .deduct_score {
      font-size: 22px;
      font-weight: 600;
      color: #ff4d4d;
    }
    .percent {
      margin: 8px 0 8px;
      color: #999;
      font-size: 14px;
      font-weight: 600;
    }
    .status {
      display: inline-block;
      margin-top: 9px;
      margin-left: 6px;
      width: 85px;
      font-size: 14px;
      color: #ff8c19;
      text-align: right;
    }
  }
  .content {
    .deduct_reason,
    .happend_time {
      padding: 0 12px;
      border-bottom: 1px solid #eee;
      // color: #333;
      .tit {
        padding: 16px 0 12px;
        font-size: 16px;
        font-weight: bold;
        color:rgba(51,51,51,1);
      }
      .desc {
        padding-bottom: 16px;
        font-size: 14px;
        line-height: 14px;
        font-weight: 400;
        color:rgba(51,51,51,1);
      }
    }
    .deal_desc {
      padding: 0 12px;
      border-bottom: 1px solid #eee;
      // color: #333;
      .tit {
        padding: 15px 0 10px;
        font-size: 16px;
        font-weight: bold;
      }
      .desc {
        padding-bottom: 10px;
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
      }
      .open_more {
        padding-bottom: 16px;
        text-align: center;
        span {
          margin-right: 5px;
          font-size: 14px;
          color: #666;
        }
        .drop_down {
          display: inline-block;
          width: 0;
          height: 0;
          border: 4px solid #9b9b9b;
          border-left-color: transparent;
          border-right-color: transparent;
          border-bottom-color: transparent;
        }
        .drop_up {
          display: inline-block;
          width: 0;
          height: 0;
          border: 4px solid #9b9b9b;
          border-left-color: transparent;
          border-right-color: transparent;
          border-top-color: transparent;
        }
      }
    }
  }
  .related_file {
    padding: 0 12px;
    .file_title {
      padding: 15px 0 16px;
      font-size: 16px;
      font-weight: bold;
      // color: #333;
    }
    .file_item {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 15px;
      .file_msg {
        flex: 1;
        display: flex;
        align-items: center;
      }
      .file_msg img {
        margin-right: 12px;
        width: 34px;
        height: 38px;
      }
      .file_msg p {
        font-size: 14px;
        color: #333;
        span {
          line-height: 20px;
          word-break: break-word;
        }
      }
      .file_size {
        font-size: 12px;
        color: #999;
      }
      .delImg {
        box-sizing: border-box;
        line-height: 38px;
        margin-left: 5px;
        margin-right: 10px;
      }
      .delImg img {
        width: 15px;
        height: 16px;
      }
    }
  }
  .bot_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    padding: 10px 16px;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
    .opreate {
      padding: 12px 0;
      div {
        display: inline-block;
      }
    }
    .delete_btn {
      margin-right: 24px;
    }
    img {
      display: inline-block;
      margin-right: 4px;
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
    span {
      display: inline-block;
      font-size: 16px;
      color: #36b374;
      vertical-align: middle;
    }
  }
  .check_btn .van-button {
    width: 203px;
    height: 40px;
    border-radius: 3px;
    background-color: #36b374;
    span {
      color: #fff;
      font-size: 16px;
      font-weight: 400;
    }
  }
}
.more_desc {
  margin-bottom: 10px;
  padding-bottom: 0 !important;
  display: inline-block;
}
.show_more {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  text-emphasis: ellipsis;
}
.line_through {
  text-decoration: line-through;
}
</style>
